import React, { } from 'react'
import { useSelector } from 'react-redux'
import TodoList from '../components/todos/TodosList';
import { Navigate } from 'react-router-dom'

const TodosPage = () => {
    const userLogin = useSelector((state) => state.userLogin)
    return (

        <>
            {userLogin && userLogin.todoUserInfo && Object.keys(userLogin.todoUserInfo).length>0?
                <TodoList /> :
                <Navigate to="/login" replace={true} />}


        </>
    )
}
export default TodosPage
